<template>
    <div class="paginator-first">
        <a v-if="disabled" class="disabled item">
            <i class="angle double left icon"></i>
        </a>
        <a v-else-if="current_page != 1" class="item" @click="$parent.change_page(1)">
            <i class="angle double left icon"></i>
        </a>
        <a v-else class="disabled item">
            <i class="angle double left icon"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: "PaginationFirst",
    props: {
        current_page: Number,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped>
</style>
